export const Config = {
    license_key:"gpl",
    file_picker_types: "file image media",
    paste_data_images: true,
    image_caption: true,
    relative_urls: true,
    browser_spellcheck: true,
    contextmenu: false,
    toolbar_sticky: true,
    menubar: false,
    plugins: [
        'advlist autoresize autolink lists link image charmap template print preview pagebreak anchor',
        'searchreplace visualblocks code fullscreen importcss emoticons',
        'insertdatetime media table paste code help codesample wordcount'
    ],
    toolbar: 'undo redo |'+ 
        ' bold italic underline forecolor | alignleft aligncenter '+ 
        'alignright alignjustify | outdent indent | numlist bullist | '+
        '| table fontsizeselect formatselect ',
    content_style: `
    @media print and (color) {
        * {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
        }
        figure.image {display: inline-block !important;}
        
    }
    body { font-family:arial; color:#34495E; } 
    figure.image {display: inline-block;border: 1px solid gray;margin: 0 2px 0 1px; background: #656565;}
    figure.align-left {float: left;}
    figure.align-right {float: right;}
    figure.image figcaption {margin: 6px 8px 6px 8px; text-align: center; font-size:14px; color:#fff;} 
    `,
    content_css:"writer",
    fontsize_formats:"8pt 9pt 10pt 11pt 12pt 14pt 18pt 20pt 24pt 26pt 28pt 30pt 32pt 34pt 36pt ",
    toolbar_mode: 'wrap',
    extended_valid_elements:[
        'table[border=1 | class=tiny-table]'
    ],
    statusbar: false,
    max_height:1000
}

export const MinConfig = {
    license_key:"gpl",
    theme_advanced_background_colors : "FF00FF,FFFF00,000000",
    file_picker_types: "file image media",
    paste_data_images: true,
    image_caption: true,
    relative_urls: true,
    browser_spellcheck: true,
    contextmenu: false,
    toolbar_sticky: true,
    menubar: false,
    plugins: [
        'advlist autoresize autolink lists link image charmap template print preview pagebreak anchor',
        'searchreplace visualblocks code fullscreen importcss emoticons',
        'insertdatetime media table paste code help codesample wordcount'
    ],
    toolbar: ' bold italic underline forecolor numlist bullist | ',
    content_style: `
    @media print and (color) {
        * {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
        }
        figure.image {display: inline-block !important;}
        
    }
    body { font-family:arial; color:#34495E; } 
    figure.image {display: inline-block;border: 1px solid gray;margin: 0 2px 0 1px; background: #656565;}
    figure.align-left {float: left;}
    figure.align-right {float: right;}
    figure.image figcaption {margin: 6px 8px 6px 8px; text-align: center; font-size:14px; color:#fff;} 
    `,
    content_css:"writer",
    fontsize_formats:"8pt 9pt 10pt 11pt 12pt 14pt 18pt 20pt 24pt 26pt 28pt 30pt 32pt 34pt 36pt ",
    toolbar_mode: 'wrap',
    extended_valid_elements:[
        'table[border=1 | class=tiny-table]'
    ],
    statusbar: false,
    max_height: 700
}

export const ViewOnly = {
    license_key:"gpl",
    elementpath:false,
    branding:false,
    readonly: 1,
    menubar: false,
    toolbar: false,
    resize:"both",
    max_height:1000,
    min_width: 300,
    plugins: 'autoresize',
    autoresize_bottom_margin: 50
}

export const ViewOnlyMini = {
    license_key:"gpl",
    elementpath:false,
    branding:false,
    readonly: 1,
    menubar: false,
    toolbar: false,
    resize:"both",
    max_height:300,
    plugins: 'autoresize',
    autoresize_bottom_margin: 50

}